import { atom } from 'jotai'

import { type ScheduleDispatchDetailRequest } from '@/features/vehicle-dispatch-boards/api'

export interface DateMismatchConfirmModalState {
  isOpen: boolean
  pendingSchedule: ScheduleDispatchDetailRequest | null
  /** 配送依頼の発送日（yyyy-MM-dd） */
  shippingDate: string | null
  /** ドロップ先の日付（yyyy-MM-dd） */
  dropDate: string | null
  /**
   * pendingSchedule を積んだドロップ元が日モードだったか。
   * 確認後の新規配車が確定した際の横スクロール追従（配車板 横スクロール追従機能）を
   * 日モード（列詰めレイアウト・時刻軸なし）ではスキップするための判定に使う
   */
  isDayMode: boolean
}

export const dateMismatchConfirmModalAtom = atom<DateMismatchConfirmModalState>(
  {
    isOpen: false,
    pendingSchedule: null,
    shippingDate: null,
    dropDate: null,
    isDayMode: false
  }
)
